import { Helmet } from 'react-helmet-async';

export const SEOProductDetail = ({ product }) => {
    const productName = product?.name || "Metal Detector";
    const productDescription = product?.description || "Unimax Metal Detector.";
    const productImage = product?.image || "https://metaldetector.co.id/default-image.jpg";
    const productURL = `https://metaldetector.co.id/product/${product?.slug || "default"}`;

    return (
        <Helmet>
            <title>Unimax Metal Detector {productName}</title>
            <meta name="description" content={`Metal Detector ${productName}, ${productName}, metal detector, unimax ${productName}`} />
            <meta
                name="keywords"
                content={`Unimax, ${productName}, Metal Detector, Unimax ${productName}, Unimax Metal Detector, Unimax Metal Detector ${productName}, Deteksi Logam, Unitek, `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content={`Unimax - ${productName}`} />
            <meta property="og:description" content={`${productDescription}`} />
            <meta property="og:image" content={productImage} />
            <meta property="og:url" content={productURL} />
            <meta property="og:type" content="website" />
            <link rel="canonical" href={productURL} />
        </Helmet>
    );
};

export const HomeSEO = () => {
    return (
        <Helmet>
            <title>Unimax Metal Detector - Mesin Deteksi Logam Akurat & Andal</title>
            <meta
                name="description"
                content="Unimax adalah brand global yang menyediakan solusi teknologi modern seperti Metal Detector, Checkweigher, X-Ray, dan Optical Sorting System untuk berbagai industri dengan kualitas tinggi dan performa andal."
            />
            <meta
                name="keywords"
                content={`Unimax, Metal Detector, Metal Detector Indonesia, Unitek Metal Detector, Unimax Metal Detector, Unitek, `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Solusi Teknologi Modern untuk Industri" />
            <meta
                property="og:description"
                content="Unimax adalah brand global yang menyediakan solusi teknologi modern seperti Metal Detector, Checkweigher, X-Ray, dan Optical Sorting System untuk berbagai industri dengan kualitas tinggi dan performa andal."
            />
            <meta property="og:image" content="https://metaldetector.co.id/default-home-image.jpg" />
            <meta property="og:url" content="https://metaldetector.co.id/" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://metaldetector.co.id/" />
        </Helmet>
    );
};

export const CatalogSEO = () => {
    return (
        <Helmet>
            <title>Unimax - Katalog Metal Detetor</title>
            <meta
                name="description"
                content="Katalog Unimax Metal Detector."
            />
            <meta
                name="keywords"
                content="Katalog Unimax, Metal Detector, Metal Detector Indonesia, Unitek Metal Detector, Unimax Metal Detector, Unitek"
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Katalog Metal Detector" />
            <meta
                property="og:description"
                content="Lihat katalog lengkap Metal Detector Unimax "
            />
            <meta property="og:image" content="https://metaldetector.co.id/catalog-image.jpg" />
            <meta property="og:url" content="https://metaldetector.co.id/catalog" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://metaldetector.co.id/catalog" />
        </Helmet>
    );
};

export const AboutSEO = () => {
    return (
        <Helmet>
            <title>Unimax Metal Detector</title>
            <meta
                name="description"
                content="Unimax adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta
                name="keywords"
                content="Unimax, Metal Detector, Metal Detector Indonesia, Unitek Metal Detector, Unimax Metal Detector, Unitek"
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Tentang Metal Detector" />
            <meta
                property="og:description"
                content="Unimax adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta property="og:image" content="https://metaldetector.co.id/about-image.jpg" />
            <meta property="og:url" content="https://metaldetector.co.id" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://metaldetector.co.id" />
        </Helmet>
    );
};


export const AddressSEO = () => {
    return (
        <Helmet>
            <title>Unimax Metal Detector</title>
            <meta
                name="description"
                content="Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03, Tangerang Regency, Banten 15710"
            />
            <meta
                name="keywords"
                content="Bislink, Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03, Tangerang Regency, Banten 15710, Citra Raya, Metal Detector Tangerang Unimax, Metal Detector, Metal Detector Indonesia, Unitek Metal Detector, Unimax Metal Detector, Unitek"
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Alamat - UnimaxMetal Detector" />
            <meta
                property="og:description"
                content="Unimax adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta property="og:image" content="https://metaldetector.co.id/about-image.jpg" />
            <meta property="og:url" content="https://metaldetector.co.id" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://metaldetector.co.id" />
        </Helmet>
    );
};
